import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useSwipeActionContext } from '../SwipeAction.provider';
import type { SwipeActionActionProps } from '../SwipeAction.types';

export const SwipeActionAction: React.FC<SwipeActionActionProps> = ({ intent = 'destructive', variant = 'solid', icon, onClick, 'aria-label': ariaLabel, overrides, children }) => {
  const { close, stayOpen } = useSwipeActionContext();

  const handleClick = () => {
    onClick?.();
    if (!stayOpen) {
      close();
    }
  };

  return (
    <ButtonV2
      intent={intent}
      variant={variant}
      flexDirection="column"
      minWidth="72px"
      minHeight="44px"
      height="100%"
      borderRadius={0}
      aria-label={ariaLabel}
      overrides={overrides}
      onClick={handleClick}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        gap={pxToRem(4)}
      >
        {icon}
        {children}
      </Flex>
    </ButtonV2>
  );
};
